import { useIntl } from 'react-intl';

import Lookup from 'src/componentes/select2';

const Condicional = (props) => {
  const intl = useIntl();

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      options={[
        {
          id: '1',
          descricao: intl.formatMessage({ id: 'sim' }),
        },
        {
          id: '2',
          descricao: intl.formatMessage({ id: 'nao' }),
        },
      ]}
      {...props}
    />
  );
};

export default Condicional;
